import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {Sorting} from "../../../../../../core/shared/misc/sorting";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";

@Component({
    selector: 'ad-statistics-component',
    templateUrl: 'ad-statistics.component.html',
    standalone: false
})
export class AdStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {

    pending: number = 0;
    processed: number = 0;
    inProcess: number = 0;
    unfinished: number = 0;


    addressHistoryWidget: WidgetData;
    addressByTypeWidget: WidgetData;
    addressByCountryWidget: WidgetData;
    recentlyAddedAddressWidget: WidgetData;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;

    overviewDto: OverviewDto[];

    constructor(
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService) {
        super(route, coreService)
    }

    ngOnInit(): void {


        this.items = [
            {label: 'AD Module'},
        ];

        this.overviewDto = [
            {label: 'Pending Registrations', value: 0},
            {label: 'Processed Registrations', value: 0},
            {label: 'In-Process Registrations', value: 0},
            {label: 'Unfinished Registrations', value: 0}
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.refreshAddressHistoryWidget();
        this.refreshAddressByTypeWidget();
        this.refreshAddressByCountryWidget();
        this.refreshAddedAddress();
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/ui/config']);
    }


    refreshAddressHistoryWidget() {
        this.addressHistoryWidget = WidgetFactory.createWidget(
            'ad.address.overview.history.widget',
            'Address History',
            'history.chart',
            'list',
            'entity.groupBy',
            'ad.Address',
            WidgetDataParam.create("fieldCategory", "city"),
            WidgetDataParam.create("fieldCategoryCount", "city_count"),
            WidgetDataParam.create("historyPeriodMode", "month"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.addressHistoryWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["city", "createdDate"],
            [new ObjectRequestListAttribute("city", "Type", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshAddressByTypeWidget() {
        this.addressByTypeWidget = WidgetFactory.createWidgetGroupBy(
            'ad.address.overview.by.type.widget',
            'Address By Type',
            'category',
            'entity.groupBy',
            'ad.Address',
            'addressType',
            'addressType_count',
            this.filterCriteria,
            'addressType',
            'Anzahl');
    }

    refreshAddressByCountryWidget() {
        this.addressByCountryWidget = WidgetFactory.createWidgetGroupBy(
            'ad.address.overview.by.country.widget',
            'Address By Country',
            'category',
            'entity.groupBy',
            'ad.Address',
            'country',
            'country_count',
            this.filterCriteria,
            'country',
            'Anzahl');
    }

    refreshAddedAddress() {

        this.recentlyAddedAddressWidget = WidgetFactory.createWidgetTableEntityBasicQl('ad.address.overview.recently.added.address', 'Recent Address', 'ad.Address', this.filterCriteriaForQuery, [new Sorting('e.createdDate', false)])

    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
